/** @format */

export interface AthletePromo {
  promoId: string | null;
  description: string;
  message: string;
  iconText: string;
  offerCode: string;
  displayTier: string;
  status: string;
  channels: string[];
  chains: string[];
  athleteAction: string;
  applicationDate: string | null;
  expirationDateTime: string;
  redeemedDate: string | null;
  pCode: string;
  pricingDiscountId: string;
  sendToPricing: boolean;
  unlimitedUses: boolean;
  availableUses: number;
  displayToAthlete: boolean;
  badgeText: string | null;
  offerLink: string | null;
  imageLink: string | null;
}

export interface StoredAthletePromo {
  error: boolean;
  promos: AthletePromo[];
}
